import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown-open",
  "use": "icon-dropdown-open-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-dropdown-open\"><path d=\"M12 6H4l4 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol